var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2470_18211)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 834,
    transform: "translate(-1029 -617)",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2470_18211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709,
    y: -26,
    width: 800,
    height: 510,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -708.5,
    y: -25.5,
    width: 799,
    height: 509,
    rx: 7.5,
    stroke: "#EBF0FA"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -1029,
    y: -617,
    width: 1440,
    height: 835,
    fill: "#28282A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20.5,
    y: -616.5,
    width: 431,
    height: 833,
    fill: "white",
    stroke: "#ECF0FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#3367CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50006 9.09997L3.75006 7.34997C3.55506 7.15497 3.24506 7.15497 3.05006 7.34997C2.85506 7.54497 2.85506 7.85497 3.05006 8.04997L5.14506 10.145C5.34006 10.34 5.65506 10.34 5.85006 10.145L11.1501 4.84997C11.3451 4.65497 11.3451 4.34497 11.1501 4.14997C10.9551 3.95497 10.6451 3.95497 10.4501 4.14997L5.50006 9.09997Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2470_18211",
    x: -721,
    y: -30,
    width: 824,
    height: 534,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2470_18211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2470_18211",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2470_18211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 834,
    fill: "white",
    transform: "translate(-1029 -617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneSmall);
export default __webpack_public_path__ + "static/media/doneSmall.373ce7b2.svg";
export { ForwardRef as ReactComponent };